// React
import { createContext } from "react"

// Types
import type { DataBillType } from "../types"

export const DataBillContext = createContext<DataBillType>({
  approve_status: 0,
  approval_status: "",
  approved_by: "",
  created_by: NaN,
  bill_status: "",
  payment_list: [],
  po_code: "",
  total_payment: 0,
  refetch: () => {}
})